"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var createContainer = function (useHook, errorMsg) {
    if (errorMsg === void 0) { errorMsg = 'Component must be wrapped with <Container.Provider />'; }
    var EMPTY = Symbol('__EMPTY__');
    var Context = react_1.default.createContext(EMPTY);
    var Provider = function (_a) {
        var initialState = _a.initialState, children = _a.children;
        var value = useHook(initialState);
        return react_1.default.createElement(Context.Provider, { value: value }, children);
    };
    var useContainer = function () {
        var value = react_1.default.useContext(Context);
        if (value === EMPTY) {
            throw new Error(errorMsg);
        }
        return value;
    };
    return { Provider: Provider, useContainer: useContainer };
};
exports.default = createContainer;
//# sourceMappingURL=create-container.js.map